import Button from '@/components/ui/button';

const CommonUI = ({ title, description, buttonText, onAction, children }) => (
  <section className="flex flex-col items-center text-center space-y-6 max-w-96">
    {children}
    <div className="space-y-2">
      <h1 className="text-2xl font-bold leading-7">{title}</h1>
      <p className="self-stretch w-full text-base text-neutral-400">
        {description}
      </p>
    </div>
    {onAction && (
      <Button tabIndex="0" variant="link" onClick={onAction}>
        {buttonText}
      </Button>
    )}
  </section>
);

export const EmptyUI = ({
  title,
  description,
  hideImage,
  buttonText,
  onAction,
}) => {
  return (
    <CommonUI
      title={title}
      description={description}
      buttonText={buttonText}
      onAction={onAction}
    >
      {!hideImage && (
        <img
          loading="lazy"
          src="/images/empty.jpg"
          alt=""
          className="w-full aspect-[1.43] max-w-[229px]"
        />
      )}
    </CommonUI>
  );
};

export const ErrorUI = ({
  title = 'Something is wrong',
  description = 'Please try again later.',
  onRetry,
}) => {
  return (
    <CommonUI
      title={title}
      description={description}
      buttonText="Try again"
      onAction={onRetry}
    >
      <svg
        width="109"
        height="108"
        viewBox="0 0 109 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.5 108C84.3234 108 108.5 83.8234 108.5 54C108.5 24.1766 84.3234 0 54.5 0C24.6766 0 0.5 24.1766 0.5 54C0.5 83.8234 24.6766 108 54.5 108ZM21.9737 47.6405C25.1546 48.5693 28.8626 45.4543 30.2558 40.683C31.649 35.9117 30.1998 31.2908 27.0189 30.362C23.838 29.4332 20.13 32.5482 18.7368 37.3195C17.3436 42.0908 18.7928 46.7117 21.9737 47.6405ZM50.5398 42.0044C49.1466 46.7757 45.4385 49.8907 42.2577 48.9619C39.0768 48.0331 37.6276 43.4122 39.0208 38.6409C40.414 33.8696 44.122 30.7546 47.3029 31.6834C50.4837 32.6122 51.9329 37.2331 50.5398 42.0044ZM34.101 78.8529C37.3427 78.1658 39.135 73.6669 38.1043 68.8044C37.0736 63.9418 33.6101 60.557 30.3684 61.2442C27.1268 61.9313 25.3344 66.4302 26.3651 71.2928C27.3959 76.1553 30.8593 79.5401 34.101 78.8529Z"
          fill="url(#paint0_radial_3391_44145)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_3391_44145"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(54.5 54) rotate(-90) scale(54 54)"
          >
            <stop stopColor="white" stopOpacity="0.2" />
            <stop offset="0.838542" stopColor="white" stopOpacity="0.1" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </CommonUI>
  );
};

export default { ErrorUI, EmptyUI };
